
const getValue = (data, path) => {
  if (typeof data !== 'object') return null;
  if (path.indexOf('.') !== -1) {
    const objectNamesArr = path.split('.');
    let result = data;
    objectNamesArr.forEach(objectName => (
      result = result && result[objectName]
    ));
    return result;
  }
  return data[path];
};

export default getValue;
